import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { colors, theme } from "../../theme/theme";
import { tagsData } from "../../assets/data";
import CustomDatePicker from "../Common/CustomDatePicker";
import CustomDropdown from "../Common/CustomDropdown";
import { CustomInput } from "../Common/CustomInput";
import { SearchOutlined } from "@mui/icons-material";
import { CustomBtn } from "../Common/CustomBtn";

const EventFilters = ({
  setDate,
  setEventType,
  setEventLocation,
  setTicketingType,
  date,
  eventType,
  eventLocation,
  ticketingType,
}) => {
  return (
    <Box sx={{ mt: 1 }}>
      <Typography sx={[theme.subHeading, { fontSize: "20px" }]}>
        Filters
      </Typography>

      <Box
        sx={{
          mt: 2,
        }}
      >
        <Typography sx={[theme.subHeading, { fontSize: "14px", mb: 0.5 }]}>
          TAGS
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          {tagsData.map((tag) => (
            <Box
              key={tag.id}
              sx={{
                border: `1px solid ${colors.secondary}`,
                borderRadius: "500px",
                px: 1,
                py: 0.5,
                fontSize: "12px",
                cursor: "pointer",
                color: colors.secondary,
                fontFamily: "Mulish-Medium",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: colors.secondary,
                  color: "white",
                },
              }}
            >
              {tag.name}
            </Box>
          ))}
        </Box>

        <Typography
          sx={[theme.subHeading, { fontSize: "14px", mt: 2, mb: 0.5 }]}
        >
          DATE
        </Typography>
        <CustomDatePicker value={date} setValue={setDate} />

        <Typography
          sx={[theme.subHeading, { fontSize: "14px", mt: 2, mb: 0.5 }]}
        >
          EVENT TYPE
        </Typography>
        <CustomDropdown
          value={eventType}
          setValue={setEventType}
          data={[
            { label: "All", value: "all" },
            { label: "Virtual", value: "virtual" },
            { label: "Physical", value: "physical" },
          ]}
          placeholder={"Select event type"}
          placeholderColor={"rgba(255,255,255,0.5)"}
        />

        <Typography
          sx={[theme.subHeading, { fontSize: "14px", mt: 2, mb: 0.5 }]}
        >
          TICKETING TYPE
        </Typography>
        <CustomDropdown
          value={ticketingType}
          setValue={setTicketingType}
          data={[
            { label: "All", value: "all" },
            { label: "Free", value: "free" },
            { label: "Paid", value: "paid" },
          ]}
          placeholderColor={"rgba(255,255,255,0.5)"}
          placeholder={"Select ticketing type"}
        />

        <Typography
          sx={[theme.subHeading, { fontSize: "14px", mt: 2, mb: 0.5 }]}
        >
          LOCATION
        </Typography>
        <CustomInput
          value={eventLocation}
          handleChange={(e) => setEventLocation(e.target.value)}
          rightIcon
          Icon={SearchOutlined}
          borderColor={"rgba(247,132,25,0.5)"}
          placeholder="Search location"
          type="text"
          bR={"9px"}
          height={"60px"}
          color={"#fff"}
          width={"100%"}
        />
      </Box>

      <CustomBtn
        text={"Apply Filters"}
        width={"100%"}
        height={"50px"}
        backgroundColor={colors.secondary}
        color={"white"}
        borderRadius={"9px"}
        fontSize={"14px"}
        fontWeight={600}
        mt={4}
        onClick={() => {}}
      />
    </Box>
  );
};

export default EventFilters;
